<template>
  <div v-if="err" class="k2-toast k2-toast--err" role="alert">
    <k2-icon n="mdi-wifi-off" :s="20" />
    <span>{{ err }}</span>
  </div>
  <div v-else-if="undo" :key="undo.at" class="k2-toast" role="status">
    <span class="k2-toast-t">{{ tx("toast.order", { id: undo.id, what: undo.label }) }}</span>
    <button type="button" data-fk="undo" @click="$emit('undo')">
      <k2-icon n="mdi-undo-variant" :s="20" />
      <span>{{ tx("undo") }}</span>
    </button>
    <i class="k2-toast-bar" :style="{ animationDuration: ms + 'ms' }"></i>
  </div>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import kds2Text from "@/mixins/kds2Text";

// Poruka na dnu: "Narudžba #4475: prihvaćena (20 min)  [Poništi]" 8 s, ili greška.
export default {
  name: "Kds2Toast",
  components: { K2Icon },
  mixins: [kds2Text],
  props: {
    undo: { type: Object, default: null },
    err: { type: String, default: "" },
    ms: { type: Number, default: 8000 },
  },
};
</script>
